import { Link, TableTd, Text, Truncated } from '@customerio/pluma-components/react';

type PersonCellProps = {
  personName: string | undefined;
  personHref: string | undefined;
};

export function RelationshipPersonCell({ personName, personHref }: PersonCellProps) {
  if (personName == null || personHref == null) {
    return (
      <TableTd>
        <Text color="subtle">—</Text>
      </TableTd>
    );
  }

  return (
    <TableTd>
      <Truncated>
        <Link href={personHref} variant="primary" className="fs-mask">
          {personName}
        </Link>
      </Truncated>
    </TableTd>
  );
}

type AttributeCountCellProps = {
  label: string;
  ariaLabel: string;
  /** Absent until the attribute preview drawer lands, which is when the count becomes a link. */
  onView: (() => void) | undefined;
};

export function RelationshipAttributeCountCell({ label, ariaLabel, onView }: AttributeCountCellProps) {
  return (
    <TableTd className="fs-mask">
      {onView == null ? (
        label
      ) : (
        <Link
          variant="secondary"
          isUnderlined
          onClick={onView}
          aria-label={ariaLabel}
          data-test-relationship-attributes-count-label
        >
          {label}
        </Link>
      )}
    </TableTd>
  );
}

type ViewCellProps = {
  onView: (() => void) | undefined;
};

export function RelationshipViewCell({ onView }: ViewCellProps) {
  return (
    <TableTd className="fs-mask">
      {onView == null ? null : (
        <Link variant="secondary" isUnderlined onClick={onView} data-test-relationship-attribute="view">
          View
        </Link>
      )}
    </TableTd>
  );
}
